export default "__VITE_ASSET__CRk6TT7m__"